<template>
    <div class="flex relative">
        <button aria-label="Search" type="button" class="flex gap-1 items-center p-1 text-gray-500 bg-gray-200 rounded appearance-none lg:rounded-none lg:p-0 hover:text-gray-900 lg:bg-transparent" @click="openModal">
            <span class="hidden lg:inline-block">Search</span>
            <search-icon class="inline-block w-6 h-6 lg:w-5 lg:h-5"></search-icon>
        </button>
        <search-modal-algolia
            ref="modal"
            :show="modalSearchToggle"
            @close-modal="closeModal">
        </search-modal-algolia>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import SearchIcon from '../../icons/Search.vue'
import SearchModalAlgolia from "../../components/forms/SearchModalAlgolia.vue"

const modalSearchToggle = ref(false)

const openModal = () => {
    modalSearchToggle.value = true
}

const closeModal = () => {
    modalSearchToggle.value = false
}
</script>
